import { CerrixPromptService } from "@app/shared/services/cerrix-prompt.service";
import { Component, EventEmitter, Input, Output, ViewChild, inject } from "@angular/core";
import { TranslocoPipe, provideTranslocoScope } from "@jsverse/transloco";
import { CerrixEditorComponent } from "@app/shared/components/cerrix-editor/cerrix-editor.component";

@Component({
    selector: "cerrix-editor-popup",
    templateUrl: "./cerrix-editor-popup.component.html",
    styleUrls: ["./cerrix-editor-popup.component.scss"],
    imports: [TranslocoPipe, CerrixEditorComponent],
    providers: [
        provideTranslocoScope({
            scope: "shared/generic-managers/generic-field-editor/custom-field-types/cerrix-editor-popup",
            alias: "cerrixEditorPopup",
        }),
    ],
})
export class CerrixEditorPopupComponent {
    private promptService = inject(CerrixPromptService);

    @Input() value: string;
    @Output() valueChange = new EventEmitter<string>();
    @ViewChild("editorTemplate") editorTemplate: any;

    loadedValue;

    // The prompt title and the close button are resolved by the transloco pipe in the
    // template (see the @let declarations) and passed in, so the prompt never needs an
    // imperative translate() before the scope is registered.
    openPopup(title: string, closeButtonText: string) {
        this.loadedValue = this.value;
        this.promptService.prompt({
            maxHeight: "800px",
            maxWidth: "1200px",
            data: {
                title: title,
                customTemplate: this.editorTemplate,
                cancelButton: {
                    text: closeButtonText,
                },
                confirmButton: {
                    show: false,
                },
            },
        });
    }
}
